export const parseZuluToLocal = (timestamp) => {
  const z = timestamp.endsWith("Z") ? timestamp : `${timestamp}Z`;
  return new Date(z);
};

export const convertBWOStimeToLocal = (timestamp) => {
  const zulu = parseZuluToLocal(timestamp);
  const local = new Date(zulu);
  return new Date(2000, 0, 1, local.getHours(), local.getMinutes(), 0, 0);
};

export const toBWOSChartTime = (input, startTime = null, endTime = null) => {
  const date = input instanceof Date ? input : new Date(input);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Optional time-range filter (based on clock time, not date)
  if (startTime || endTime) {
    const timeAsMinutes = hours * 60 + minutes;
    const startMinutes =
      startTime instanceof Date
        ? startTime.getHours() * 60 + startTime.getMinutes()
        : 0;
    const endMinutes =
      endTime instanceof Date
        ? endTime.getHours() * 60 + endTime.getMinutes()
        : 1440;

    if (timeAsMinutes < startMinutes || timeAsMinutes > endMinutes) return null;
  }

  // Normalize to reference day
  return new Date(2000, 0, 1, hours, minutes, 0, 0);
};

// ⚠️ NOTE: This logic assumes the BWOS server uses local Norway time.
export const getCurrentBWOSHourRange = () => {
  const now = new Date();

  const utcYear = now.getUTCFullYear();
  const utcMonth = now.getUTCMonth();
  const utcDate = now.getUTCDate();
  const utcHour = now.getUTCHours();

  const startOfCurrentHour = new Date(
    Date.UTC(utcYear, utcMonth, utcDate, utcHour + 2)
  );
  const startOfNextHour = new Date(
    Date.UTC(utcYear, utcMonth, utcDate, utcHour + 3)
  );

  const format = (d) => d.toISOString().slice(0, 16);

  return {
    dateFrom: format(startOfCurrentHour),
    dateTo: format(startOfNextHour),
  };
};
